<template>
  <div>
    <div class="grid-container" >
      <div class="block1 " v-show="isSingle == false">
        <search-control-block :all_disabled="b1_disabled" block_id="1" @change="onChange" :block_contorler="b1Controller" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>
      </div>
      <div class="" v-show="isSingle == true" style="width:320px;">
        <search-control-block :all_disabled="b1_disabled" block_id="1" @change="onChange" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>
      </div>
      <div class="join1 " v-show="isSingle == false">
         <select  class="form-control select-box" :disabled="j1_disabled"
            style="height:24px;padding:0px 0px;marging:0px 0px 0px 0px;font-size:12px;width: 65px;margin: 0 auto;;"
              @change="andOr($event.target.value,'j1')" 
              :value="joinValue1"
              id="and_or_2"  name="and_or_2" >
              <option>AND</option>
              <option>OR</option>
              <option v-if="j1EnabledBetween" value="BETWEEN">~</option> <!--  search_with_between  step1 -->
          </select>
      </div>
      <div class="block2 "  v-show="isSingle == false">
          <search-control-block  :all_disabled="b2_disabled" block_id="2" @change="onChange" :block_contorler="b2Controller" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>

      </div>
      <div class="join2 "  v-show="isSingle == false">
       <select  class="form-control select-box" :disabled="j2_disabled"
                style="height:24px;padding:0px 0px;marging:0px 0px 0px 0px;font-size:12px;width: 65px;margin: 0 auto;;"
                  @change="andOr($event.target.value,'j2')" 
                  :value="joinValue2"
                  id="and_or_2"  name="and_or_2" >
                  <option>AND</option>
                  <option>OR</option>
                  <option v-if="j2EnabledBetween" value="BETWEEN">~</option><!--  search_with_between step2 -->
              </select>
      </div>
      <div class="block3 "  v-show="isSingle == false">
        <search-control-block :all_disabled="b3_disabled" block_id="3" @change="onChange"  :block_contorler="b3Controller" :field_names="field_names"  
            style="padding:0px 0px;marging:0px 0px 0px 0px;" ></search-control-block>

      </div>
      <div class="block_btn "  v-show="isSingle == false">
        <button 
          style="width: 100px;float: left;margin-left: 15px;" 
          class="btn btn-primary esma_btn_form btn-xs" @click="clearBarcode">検索クリア</button>
      </div>

    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import { bus } from '@/libs/bus'
import Vue from 'vue';

import debug from 'debug';
var debug_search_control = debug('esma:page_common');
import {filed_types} from "@/rules/fields";
import searchControlBlock from "@/components/search_control_block";
import { bus } from '@/libs/bus'

export default {
  components: {
    "search-control-block": searchControlBlock
  },
  data() {
    return {
      bock_info:{1:false,2:false,3:false,j1:"AND",j2:"AND",b2_disabled:false,b3_disabled:false},
      b1_disabled:false,
      j1_disabled:true,
      b2_disabled:true,
      j2_disabled:true,
      b3_disabled:true,
      j1_enabled_between:false, // search_with_between step3
      j2_enabled_between:false,
      join_value_1:"AND",
      join_value_2:"AND",
      b1_controller:{},
      b2_controller:{},
      b3_controller:{},

    };
  },

  computed: {
    b1Controller:{
      get(){
        return this.b1_controller;
      },
      set(v){
        this.b1_controller = v;
      }
    },
    b2Controller:{
      get(){
        return this.b2_controller;
      },
      set(v){
        this.b2_controller = v;
      }
    },
    b3Controller:{
      get(){
        return this.b3_controller;
      },
      set(v){
        this.b3_controller = v;
      }
    },
    joinValue1:{
      get(){
        return this.join_value_1;
      },
      set(v){
        this.join_value_1 = v;
      }
    },
    joinValue2:{
      get(){
        return this.join_value_2;
      },
      set(v){
        this.join_value_2 = v;
      }
    },
    j1EnabledBetween:{
      get(){
        return this.j1_enabled_between;
      },
      set(v){
        this.j1_enabled_between = v;
      }
    },
    j2EnabledBetween:{
      get(){
        return this.j2_enabled_between;
      },
      set(v){
        this.j2_enabled_between = v;
      }
    },
    filedList(){
      return this.field_names.map(o=>{
        return {id:o.id,label:o.label,type:o.type}
      })
    },
    dateFilterOptions: {
      get() {
        return [];
      },
      set(v) {
      }
    },
    isSingle(){
      return this.single == true;
    }
  },
  methods: {
    clearBarcode(ev){
      ev.preventDefault();
      this.$store.state.search_dependency_groups = {};
      this.$store.state.search_data = {};
      bus.$emit("onSearchClear","");
      this.$emit("onSearchClear","");
      this.joinValue1 = "AND";
      this.joinValue2 = "AND";
    },
    andOr(v,id)
    {
      this.$store.state.search_data[id] =v;
      if(v == "BETWEEN"){
        this.j1EnabledBetween = true;
      }
      if(id == "j1"){
        this.joinValue1 = v
        if(v == "BETWEEN"){
          this.j1EnabledBetween = true;
          this.b2Controller.enableOnly(this.b1Controller.getSelectedFieldName())
        }else{
          this.j1EnabledBetween = false;
          this.b2Controller.enableOnly("all")
        }
      }
      if(id == "j2"){
        this.joinValue2 = v
        if(v == "BETWEEN"){
          this.j2EnabledBetween = true;
          this.b3Controller.enableOnly(this.b2Controller.getSelectedFieldName())
        }else{
          this.j2EnabledBetween = true;
          this.b3Controller.enableOnly("all")
        }
      }
      this.bock_info[id] = v;
      this.processAndEmit();
    },
    onChange(d){
      if(typeof this.$store.state.search_data == "undefined"){
        this.$store.state.search_data = {};
      }
      this.$store.state.search_data[d.block] = d
      this.bock_info[d.block] = d
      this.processAndEmit();
    },
    processAndEmit(){
       this.b2_disabled = false;
      this.b3_disabled = false;
      this.j1_disabled = false;
      this.j2_disabled = false;
      this.j1EnabledBetween = false; // search_with_between step4
      this.j2EnabledBetween = false;
      if(this.bock_info["1"] == false || this.bock_info["1"].value==""){
        this.b2_disabled = true;
        this.b3_disabled = true;
        this.j1_disabled = true;
        this.j2_disabled = true;
      }
      if(this.bock_info["2"] == false || this.bock_info["2"].value==""){
        this.b3_disabled = true;
        this.j2_disabled = true;
      }
      // search_with_between step5
      // if(this.bock_info["1"] != false && this.bock_info["2"] != false && this.bock_info["1"].field == this.bock_info["2"].field && ( this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0) ){
      //   //this.j1EnabledBetween = true; 
      // }else if(this.bock_info.j1 == "BETWEEN"){
      //  // this.bock_info.j1 = "AND";
      // }
      if(this.bock_info["1"] != false && this.bock_info["1"].t &&  ( this.bock_info["1"].t.indexOf('datetime_picker') == 0 || this.bock_info["1"].t.indexOf('current_time') == 0 || this.bock_info["1"].t.indexOf('date_picker') == 0) ){
        this.j1EnabledBetween = true; 
      }else if (this.bock_info["2"] != false) {
        if(this.bock_info["j1"] == "BETWEEN"){
          this.andOr("AND","j1")
        }
      }




      // if(this.bock_info["2"] != false && this.bock_info["3"] != false && this.bock_info["2"].field == this.bock_info["3"].field  && ( this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0) ){
      //   this.j2EnabledBetween = true;
      // }else if(this.bock_info.j2 == "BETWEEN"){
      //   this.bock_info.j2 = "AND";
      // }

      if(this.bock_info["2"] != false && this.bock_info["2"].t && ( this.bock_info["2"].t.indexOf('datetime_picker') == 0 || this.bock_info["2"].t.indexOf('current_time') == 0 || this.bock_info["2"].t.indexOf('date_picker') == 0) ){
        this.j2EnabledBetween = true; 
      }else if (this.bock_info["3"] != false) {
        // this.andOr("AND",2)
        if(this.bock_info["j2"] == "BETWEEN"){
          this.andOr("AND","j2")
        }
      }
      this.bock_info["b2_disabled"] = this.b2_disabled ;
      this.bock_info["b3_disabled"] = this.b3_disabled ;
      console.log("Data changed",JSON.stringify(this.bock_info,null,4))
      this.$emit("change",this.bock_info);
    },
    onFilterTypeSelected(val, id){
      console.log({val,id})
    },
    onDateFilterSelected() {
    }
  },
  beforeMount() {},
  mounted() {
    this.$store.state.search_dependency_groups = {};
    this.$store.state.search_data = {};
    // May use it to recreate the list of allowed items to search. 
    // After this, it is necessary to visit each page.
    // var arr =  JSON.parse(Vue.localStorage.get('temp_search_fields') || "[]");
    // this.field_names.map((o)=>{return o.id}).forEach(f=>{
    //   if(arr.indexOf(f) < 0){
    //     arr.push(f)
    //   }
    // })
    // Vue.localStorage.set('temp_search_fields', JSON.stringify(arr)) 
    // console.log("field_names",arr)
    bus.$on("onOpenPageFilterJoin1",(data) =>{
      console.log('TEST DEBUG 210608 (273 at search_control.vue)[01:38]: ', {  });
      setTimeout(()=>{
        this.andOr(data,"j1")
      },200)
    });
    bus.$on("onOpenPageFilterJoin2",(data) =>{
      console.log('TEST DEBUG 210608 (279 at search_control.vue)[01:38]: ', {  });
       setTimeout(()=>{
        this.andOr(data,"j2")
      },200)
    });

    // setInterval(() => {
    // }, 1000);
  },
  afterMount() {},
  beforeDestroy() {
    bus.$off("onOpenPageFilterJoin1")
    bus.$off("onOpenPageFilterJoin2")
  },
  props: ['field_names','single']
};
</script>

<style scoped>
.grid-container {
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 40fr 10fr 40fr 10fr 40fr 15fr;
  grid-template-columns: 40fr 10fr 40fr 10fr 40fr 15fr;
  -ms-grid-rows: 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "block1  join1  block2  join2  block3 block_btn";
}

.block1  { -ms-grid-row: 1; -ms-grid-column: 1; grid-area: block1 ; }

.join1  { -ms-grid-row: 1; -ms-grid-column: 2; grid-area: join1 ; }

.block2  { -ms-grid-row: 1; -ms-grid-column: 3; grid-area: block2 ; }

.join2  { -ms-grid-row: 1; -ms-grid-column: 4; grid-area: join2 ; }

.block3  { -ms-grid-row: 1; -ms-grid-column: 5; grid-area: block3 ; }

.block_btn  { -ms-grid-row: 1; -ms-grid-column: 6; grid-area: block_btn ; }
</style>



// WEBPACK FOOTER //
// search_control.vue?56c97116